// extracted by mini-css-extract-plugin
export default {"close_icon":"howItsWork_close_icon__H5bOg","carousel_header":"howItsWork_carousel_header__kNYHQ","carousel_image":"howItsWork_carousel_image__IjCE3"};